import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import AppointmentPrice$1 from './AppointmentPrice.js';

const AppointmentPriceContainer = (_param)=>{
    var { amount , currency , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currency",
        "className"
    ]);
    const { isAppointmentBookingTypeWithFreeIndication  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const isFree = React.useMemo(()=>amount === 0
    , [
        amount
    ]);
    const labels = React.useMemo(()=>({
            freeIndication: isAppointmentBookingTypeWithFreeIndication && isFree ? `${getLabel('common.free')}` : ''
        })
    , [
        isAppointmentBookingTypeWithFreeIndication,
        isFree,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentPrice$1, swcHelpers.extends({}, {
        amount,
        currency,
        labels,
        className
    }, rest));
};
var AppointmentPrice = AppointmentPriceContainer;

export { AppointmentPrice as default };
//# sourceMappingURL=AppointmentPriceContainer.js.map
